import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "environments/environment";
import { ClusterResponse } from "app/core/models/cluster-response";
import { ClusterProfileResponse } from "app/core/models/cluster-profile-response";

@Injectable()
export class ClusterService {

  constructor(private readonly _httpClient: HttpClient) { }

  public getClusters(filter: string, sortDirection: 'asc' | 'desc'| '', sortField: string, 
                      pageIndex: number, pageSize: number, activeFilters: Object[]): Observable<ClusterResponse> {
    
    let allStringFilterAux = [];
    activeFilters.forEach((item, index) => {
      if (item['value'] != null && item['value'] != '') {
        let stringFilterAux = [item['id'],item['value']];
        allStringFilterAux.push(stringFilterAux.join('::'));
      }
    });

    let queryFilter = allStringFilterAux.join('--');

    
    let params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '')
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/clusters`, {
      params: params
      }).pipe(
          
          map(res =>  <ClusterResponse>res)
      );
  }

    public getClusterProfiles(filter: string, sortDirection: 'asc' | 'desc'| '', sortField: string, 
                      pageIndex: number, pageSize: number, activeFilters: Object[], idElement: string = null): Observable<ClusterProfileResponse> {
    
    let allStringFilterAux = [];
    activeFilters.forEach((item, index) => {
      if (item['value'] != null && item['value'] != '') {
        let stringFilterAux = [item['id'],item['value']];
        allStringFilterAux.push(stringFilterAux.join('::'));
      }
    });

    let queryFilter = allStringFilterAux.join('--');

    
    let params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '')
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/clusters/${idElement}/profiles`, {
      params: params
      }).pipe(
          
          map(res =>  <ClusterProfileResponse>res)
      );
  }


  getClusterStatus(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/clusters/status`);
  }

  getClusterSource(): Observable < any > {
    return this._httpClient.get(`${environment.apiUrl}/clusters/source`);
}

  getClustersList(organizationId): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/clusters?f=organizationId::${organizationId}`);
  }

  getCluster(id: string): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/clusters/${id}`);
  }

  createCluster(cluster: any): Observable < any > {
      return this._httpClient.post(`${environment.apiUrl}/clusters`, cluster);
  }

  editCluster(cluster: any, id: string): Observable < any > {
      return this._httpClient.put(`${environment.apiUrl}/clusters/${id}`, cluster);
  }

  deleteCluster(id: string): Observable < any > {
      return this._httpClient.delete(`${environment.apiUrl}/clusters/${id}`);
  }

  addProfile(clusterId: string, profileId: string): Observable < any > {
      return this._httpClient.post(`${environment.apiUrl}/clusters/${clusterId}/profiles`, { profiles: [profileId] });
  }
}
